module.exports = __webpack_public_path__ + "media/images/video-981e8239ab47ef39d4754c309245d363.svg";